// extracted by mini-css-extract-plugin
export var statItem = "_gn-1";
export var statsRow = "_gn-0";